<template>
  <div class="w-full h-full bg-login absolute top-0 left-0 flex flex-col md:flex-row items-center justify-center">
    <div class="md:order-2 w-full md:w-1/2 xl:w-1/3 p-2 md:p-8 relative max-w-sm md:max-w-full" style="min-height:260px">
      <transition name="fade-up">
        <div v-if="!resetpwd">
          <img class="h-14 w-auto" src="~@/assets/img/logos/logo-obenasa-inv.png" alt="">
          <span class="h-1 bg-secondary w-20 inline-block" />
          <h2 class="text-4xl text-white font-bold">
            Gestión de facturas de proveedores de servicios
          </h2>
        </div>
      </transition>
      <transition name="fade-up">
        <div v-if="resetpwd && !mailsent" class="mt-4">
          <h2 class="text-4xl text-white font-bold">
            ¿Olvidaste la contraseña?
          </h2>
          <span class="h-1 bg-secondary w-20 inline-block" />
          <p class="text-lg mt-2 text-white">Introduce la dirección de correo asociada a tu cuenta.</p>
        </div>
      </transition>
      <transition name="fade-up">
        <div v-if="mailsent" class="mt-4">
          <h2 class="text-4xl text-white font-bold">
            Compruebe su email
          </h2>
          <span class="h-1 bg-secondary w-20 inline-block" />
          <p class="text-lg mt-2 text-primary-100">Le hemos enviado un correo a <strong class="text-white">{{email}}</strong> con las instrucciones para restaurar su contraseña.</p>
        </div>
      </transition>
    </div>
    <div class="md:order-1 w-full md:w-1/2 xl:w-1/3 max-w-sm px-2">
      <div class="w-full bg-primary-800 p-6 rounded-lg border border-solid border-primary-200">
        <p  v-if="error" class="text-lg mt-2 text-primary-100">Login no válido</p>
        <transition name="toggle-input-nolabel">
          <Input v-if="!mailsent" class="mb-2" id="email" placeholder="Email…" v-model="email"/>
        </transition>
        <transition name="login">
          <div v-if="!resetpwd">
            <Input type="password" class="mb-2" id="pwd" placeholder="Contraseña…" v-model="pwd"/>
            <div class="flex items-center mb-6 pl-1">
              <p @click="resetpwd = true" class="text-xs text-primary-300 hover:text-secondary cursor-pointer ml-auto">¿Olvidaste la contraseña?</p>
            </div>
            <div>
              <Button class="w-full" @click="onLogin()"  type="primary">Login</Button>
            </div>
          </div>
        </transition>
        <transition name="reset-pwd">
          <div v-if="resetpwd">
            <transition name="mailsent">
              <div v-if="mailsent" class="text-center">
                <div class="check-wrap my-8 m-auto"></div>
                <p class="block"> Email enviado con éxito</p>
              </div>
            </transition>
            <Button v-if="!mailsent" @click="onReset()" :loading="loading" class="w-full" type="primary">Recuperar contraseña</Button>
            <p @click="resetpwd = false, mailsent = false" class="mt-3 text-center w-full inline-block text-xs text-primary-300 hover:text-secondary cursor-pointer ml-auto">Volver a login</p>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { Input, Button } from 'element-ui'
import login from '../utils/portalLogin'
import recuperarPassword from '../utils/portalRecuperarPassword'

export default {
  name: 'login',

  mounted () {
    this.$store.commit('setLoading', true)
    if (localStorage.getItem('token')) {
      this.$router.push({ name: 'documentList', params: { state: 1 } })
    }
  },

  components: {
    Input,
    Button
  },
  data () {
    return {
      email: '',
      pwd: '',
      remember: false,
      resetpwd: false,
      mailsent: false,
      error: false
    }
  },
  methods: {
    async onLogin () {
      try {
        const { Estado, Mensaje, JWTToken, CIFs } = await login(this.email, this.pwd)

        if (Estado === 'KO') {
          this.error = true
        } else {
          localStorage.setItem('token', JWTToken)
          localStorage.setItem('email', this.email)
          localStorage.setItem('cifs', JSON.stringify(CIFs))
          this.$store.commit('setFacturasDataSource', [])
          this.$router.push({ name: 'documentList', params: { state: 1 } })
        }
      } catch (error) {
        this.error = true
      }
    },

    async onReset () {
      try {
        const { Estado, Mensaje } = await recuperarPassword(this.email)

        if (Estado === 'KO') {
          alert('Ha ocurrido un error, por favor intentelo más tarde')
          console.log(Mensaje)
        } else {
          this.mailsent = true
        }
      } catch (error) {
        console.log(error.response)
      }
    }
  }
}
</script>
